import React from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Avatar,
  InputBase,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Stack,
  Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { styled } from "@mui/material/styles";
import { StyledCellHeader } from "../../../../components/StyledCellHeader";
import { RemoveRedEyeOutlined, Receipt, TrendingUp, Assessment, Payment } from "@mui/icons-material";
import CrearProveedorDialog from "../proveedores/crearproveedordialog";
import { fetchProveedores } from "../../../../utils/generalsFetch";
import { useNavigate } from "react-router-dom";
import AccessDeniedBox from '../../../../components/AccessDeniedBox';
import EmptyState from '../../../../components/EmptyState';


const StatusChip = ({ status }) => (
  <Chip
    label={status}
    color={status === "Active" ? "success" : "default"}
    size="small"
    sx={{ minWidth: 80 }}
  />
);

const SearchPaper = styled(Paper)(({ theme }) => ({
  padding: "2px 8px",
  display: "flex",
  alignItems: "center",
  background: "#f0f2f4",
  minWidth: 200,
  maxWidth: 300,
  borderRadius: "8px",
  boxShadow: "none",
}));

export default function FacturasProveedores() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage] = React.useState(8);
  const [search, setSearch] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [proveedores, setProveedores] = React.useState([]);
  const navigate = useNavigate();
  const [facturas, setFacturas] = React.useState([]);
  const [accessDenied, setAccessDenied] = React.useState(false);
  React.useEffect(() => {
    fetchProveedores({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProveedores(data);
    }).then(() => {
      fetchFacturas();
    }).catch((error) => {
      setAccessDenied(true);
    });
  }, []);

  async function fetchFacturas(){
    const response = await fetch(process.env.REACT_APP_SERVER_URL+`/api/facturas-compra/${localStorage.getItem('idcompany')}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
      },
    });
    const data = await response.json();
    if(data["error"]!="Acceso denegado"){
      setAccessDenied(false);
      setFacturas(data);
    }else{
      setAccessDenied(true);
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtered = facturas.filter((row) =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );
  return (
    <Box sx={{ fontFamily: "Inter, Noto Sans, sans-serif", bgcolor: "#fff", minHeight: "100vh" }}>

      <CrearProveedorDialog open={open} onClose={()=>{setOpen(false)}}/>
      <Box >
        <Box display="flex" justifyContent="end" mb={2}>
          <Button
            variant="contained"
            color="primarybutton"
            startIcon={<AddIcon />}
            sx={{
              fontWeight: "bold",
              fontSize: 15,
              boxShadow: "none",
              minWidth: 120,
            }}                  
            onClick={()=>{navigate('/logistica/compras/facturas-proveedor/crear')}}
          >
            Crear Factura
          </Button>
        </Box>

        {!accessDenied ? 
        <>
        {/* Show empty state if no invoices */}
        {facturas.length === 0 ? (
            <EmptyState 
                icon={Receipt}
                title="No hay facturas de proveedores"
                description="Comienza creando tu primera factura de proveedor para gestionar los pagos y controlar las obligaciones comerciales de manera eficiente."
                features={[
                    {
                        icon: Payment,
                        title: "Control de Pagos",
                        description: "Gestión completa de obligaciones y pagos"
                    },
                    {
                        icon: TrendingUp,
                        title: "Seguimiento Financiero",
                        description: "Monitoreo de montos pagados y pendientes"
                    },
                    {
                        icon: Assessment,
                        title: "Reportes de Facturación",
                        description: "Análisis de gastos y flujo de efectivo"
                    }
                ]}
                buttonText="Crear Primera Factura"
                onButtonClick={() => navigate('/logistica/compras/facturas-proveedor/crear')}
                helpText="¿Necesitas ayuda? Contacta a soporte técnico para guiarte en el proceso"
            />
        ) : (
            <>
            <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: "none", minHeight: "500px" }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: "#fff" }}>
                    <StyledCellHeader align="center"># Factura</StyledCellHeader>
                    <StyledCellHeader>Proveedor</StyledCellHeader>
                    <StyledCellHeader>Total</StyledCellHeader>
                    <StyledCellHeader>Pagado</StyledCellHeader>
                    <StyledCellHeader>Por Pagar</StyledCellHeader>
                    <StyledCellHeader>Estado</StyledCellHeader>
                    <StyledCellHeader>Creacion</StyledCellHeader>
                    <StyledCellHeader align="center"></StyledCellHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filtered
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => (
                      <TableRow key={idx} hover>
                        <TableCell align="center">{row.numero_factura}</TableCell>
                        <TableCell>{row.proveedor_name}</TableCell>
                        <TableCell>{row.monto_total}</TableCell>
                        <TableCell>{row.monto_pagado}</TableCell>
                        <TableCell>{row.monto_total - row.monto_pagado}</TableCell>
                        <TableCell>
                          <StatusChip status={row.estado_pago} />
                        </TableCell>
                        <TableCell>{row.fecha_emision}</TableCell>
                        <TableCell align="center">
                          <IconButton size="small" sx={{ color: "#617689" }} onClick={()=>{navigate(`/logistica/compras/facturas-proveedor/editar/${row.id}`)}}>
                            <RemoveRedEyeOutlined/>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <TablePagination
                component="div"
                count={filtered.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[8]}
                labelRowsPerPage=""
              />
            </Box>
            </>
        )}
        </>
        :
        <Box>
          <br></br>
          <br></br>
          <AccessDeniedBox
            title={'Acceso denegado'}
            message={'No tienes permisos para ver esta sección de Facturas de Proveedores. Contacta a tu administrador para solicitar acceso o verifica tus roles y permisos.'}
          />
        </Box>
        }
      </Box>
    </Box>
  );
};

